import { BaseWidgetEntityWithWellId } from 'src/entities/widget/BaseWidgetEntityWithWellId';

import type { WellListPanelEntity } from '../features/well-list-panel/WellListPanel.entity';
import type { WidgetEntity } from 'src/entities/widget/WidgetEntity';

function findFirstWellIdAmongWidgets(widgets: WidgetEntity[], currentWidget: WidgetEntity): number | null {
  for (const widget of widgets) {
    if (widget instanceof BaseWidgetEntityWithWellId) {
      if (widget === currentWidget) {
        continue;
      }

      if (widget.wellId !== null) {
        return widget.wellId;
      }
    }
  }

  return null;
}

function findFirstWellIdWidgets(widgets: WidgetEntity[]): number | null {
  for (const widget of widgets) {
    if (widget instanceof BaseWidgetEntityWithWellId) {
      if (widget.wellId !== null) {
        return widget.wellId;
      }
    }
  }

  return null;
}

export function setWellIdInGroup(
  widgets: WidgetEntity[],
  currentWidget: WidgetEntity,
  wellListPanelEntity: WellListPanelEntity | null
): void {
  let currentWellId: null | number = null;

  const isWidgetWithWellId = currentWidget instanceof BaseWidgetEntityWithWellId;

  if (isWidgetWithWellId) {
    currentWellId = currentWidget.wellId;
  }

  let foundWellId = findFirstWellIdAmongWidgets(widgets, currentWidget);

  if (!foundWellId && wellListPanelEntity && wellListPanelEntity.groupId === currentWidget.groupId) {
    foundWellId = wellListPanelEntity?.selectedWellID ?? null;
  }

  if (foundWellId === null && currentWellId === null) return;

  if (foundWellId !== null) {
    if (isWidgetWithWellId) {
      currentWidget.setWellId(foundWellId);
    }
  } else if (currentWellId !== null) {
    for (const widget of widgets) {
      if (widget instanceof BaseWidgetEntityWithWellId) {
        widget.setWellId(currentWellId);
      }
    }
    wellListPanelEntity?.setWellId(currentWellId);
  }
}

export function setWellIdInGroupById(widgets: WidgetEntity[], wellId?: number | null): number | null {
  const foundWellId = findFirstWellIdWidgets(widgets);

  if (foundWellId != null) {
    return foundWellId;
  } else {
    if (wellId == null) {
      return null;
    }

    for (const widget of widgets) {
      if (widget instanceof BaseWidgetEntityWithWellId) {
        widget.setWellId(wellId);
      }
    }
  }
  return null;
}
